import Vuex from 'vuex';
import _ from 'lodash';
import SaveMixin from '../../mixins/SaveMixin';
export default {
  state: {
    language: 'EN',
    supportedLanguages: [],
    translations: {}
  },
  mutations: {
    setLanguage(state, payload) {
      _.merge(state, payload)
    },
    setDirty (state, payload) {
      // NOOP
    }
  },
  getters: {
    multilingual (state) {
      return state.supportedLanguages.length > 1
    }
  }
}